
import { Component, ChangeDetectionStrategy, input, output, effect, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
// FIX: Corrected import path for models.
import { LoyaltyReward } from '../../models/index';
import { TranslatePipe } from '../../pipes/translate.pipe';

@Component({
  selector: 'app-reward-form-modal',
  standalone: true,
  templateUrl: './reward-form-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, TranslatePipe],
})
export class RewardFormModalComponent {
  reward = input<LoyaltyReward | null>();
  isOpen = input.required<boolean>();
  
  closeModal = output<void>();
  saveReward = output<Omit<LoyaltyReward, 'id' | 'createdAt'> | LoyaltyReward>();

  rewardForm: FormGroup;

  constructor() {
    // FIX: Explicitly type FormBuilder to resolve an issue where inject() was returning 'unknown'.
    const fb: FormBuilder = inject(FormBuilder);
    this.rewardForm = fb.group({
      id: [null],
      name: ['', Validators.required],
      points_required: [0, [Validators.required, Validators.min(0)]],
      cost: [0, [Validators.required, Validators.min(0)]],
      sku: ['', Validators.required],
      imageUrl: [''],
      tag: [''],
      description: [''],
      monthly_limit: [null],
      active: [true, Validators.required],
    });

    effect(() => {
        const rewardData = this.reward();
        if (rewardData) {
            this.rewardForm.patchValue(rewardData);
        } else {
            this.rewardForm.reset({
                id: null,
                name: '',
                points_required: 0,
                cost: 0,
                sku: '',
                imageUrl: '',
                tag: '',
                description: '',
                monthly_limit: null,
                active: true,
            });
        }
    });
  }

  onClose(): void {
    this.closeModal.emit();
  }

  onSave(): void {
    if (this.rewardForm.valid) {
      this.saveReward.emit(this.rewardForm.value);
    }
  }

  onBackdropClick(event: MouseEvent): void {
      if (event.target === event.currentTarget) {
          this.onClose();
      }
  }
}
